import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Header
      'header.search': 'Search for relaxation...',
      'header.shop': 'Shop',
      'header.collections': 'Collections',
      'header.collectibleToys': 'Collectible Toys',
      'header.decor': 'Decor',
      'header.shopByBrand': 'Shop by Brand',
      'header.shopByCategories': 'Shop by Categories',
      'header.about': 'About',
      'header.blog': 'Blog',
      'header.help': 'Help',
      'header.topBanner': 'Free US Shipping on Orders $75+ • We create comfort in your life • Premium Wellness Products',
      'header.tagline': 'We create comfort in your life',
      
      // Hero
      'hero.newArrivals': 'NEW ARRIVALS',
      'hero.title1': 'Transform Your Space Into A Sanctuary',
      'hero.subtitle1': 'Premium wellness essentials for peaceful living',
      'hero.cta1': 'SHOP NOW',
      'hero.title2': 'Sleep Like Never Before',
      'hero.subtitle2': 'Science-backed products for deeper rest',
      'hero.cta2': 'EXPLORE COLLECTION',
      'hero.title3': 'Sound Healing Collection',
      'hero.subtitle3': 'Meditative instruments for your soul',
      'hero.cta3': 'DISCOVER MORE',
      
      // Categories
      'categories.title': 'Shop by Category',
      'categories.subtitle': 'Find exactly what brings you peace',
      'categories.products': 'products',
      
      // Best Sellers
      'bestSellers.badge': '⭐ CUSTOMER FAVORITES',
      'bestSellers.title': 'Best Sellers',
      'bestSellers.subtitle': 'Trusted by thousands for relaxation',
      'bestSellers.cta': 'Explore All Products',
      
      // USP
      'usp.shipping.title': 'Free Shipping',
      'usp.shipping.text': 'On orders $75+',
      'usp.returns.title': 'Easy Returns',
      'usp.returns.text': '30-day guarantee',
      'usp.secure.title': 'Secure Checkout',
      'usp.secure.text': 'SSL encrypted',
      
      // Footer
      'footer.newsletter.title': 'Join Our Peaceful Community',
      'footer.newsletter.subtitle': 'Get wellness tips, exclusive offers, and peaceful inspiration',
      'footer.newsletter.placeholder': 'Enter your email',
      'footer.newsletter.button': 'Subscribe',
      'footer.tagline': 'Against anxiety. For comfort in every home.',
      'footer.since': 'Since 2024',
      'footer.shop': 'Shop',
      'footer.collections': 'Collections',
      'footer.company': 'Company',
      'footer.shopBy': 'Shop By',
      'footer.categories': 'CATEGORIES',
      'footer.brands': 'BRANDS',
      'footer.weAccept': 'We accept:',
      'footer.copyright': 'Crafted with mindfulness.',
      'footer.privacy': 'Privacy',
      'footer.terms': 'Terms',
      'footer.accessibility': 'Accessibility',
      
      // Product Card
      'product.addToCart': 'Add to Cart',
      'product.addToWishlist': 'Add to Wishlist',
      'product.inStock': 'In stock',
      'product.outOfStock': 'Out of stock',
      'product.lowStock': 'Low stock',
      'product.bestSeller': 'Best Seller',
      'product.new': 'New',
      
      // Common
      'common.viewAll': 'View All',
      'common.loading': 'Loading...',
      'common.allProducts': 'All Products',
      'common.newArrivals': 'New Arrivals',
      'common.sale': 'Sale',
      'common.aboutUs': 'About Us',
      'common.helpCenter': 'Help Center',
      'common.contact': 'Contact'
    }
  },
  es: {
    translation: {
      // Header
      'header.search': 'Buscar relajación...',
      'header.shop': 'Tienda',
      'header.collections': 'Colecciones',
      'header.collectibleToys': 'Juguetes Coleccionables',
      'header.decor': 'Decoración',
      'header.shopByBrand': 'Comprar por Marca',
      'header.shopByCategories': 'Comprar por Categorías',
      'header.about': 'Nosotros',
      'header.blog': 'Blog',
      'header.help': 'Ayuda',
      'header.topBanner': 'Envío Gratis en Pedidos de $75+ • Creamos comodidad en tu vida • Productos Premium de Bienestar',
      'header.tagline': 'Creamos comodidad en tu vida',
      
      // Hero
      'hero.newArrivals': 'NUEVOS PRODUCTOS',
      'hero.title1': 'Transforma Tu Espacio En Un Santuario',
      'hero.subtitle1': 'Productos premium de bienestar para una vida pacífica',
      'hero.cta1': 'COMPRAR AHORA',
      'hero.title2': 'Duerme Como Nunca Antes',
      'hero.subtitle2': 'Productos respaldados por la ciencia para un descanso profundo',
      'hero.cta2': 'EXPLORAR COLECCIÓN',
      'hero.title3': 'Colección de Sanación con Sonido',
      'hero.subtitle3': 'Instrumentos meditativos para tu alma',
      'hero.cta3': 'DESCUBRIR MÁS',
      
      // Categories
      'categories.title': 'Comprar por Categoría',
      'categories.subtitle': 'Encuentra exactamente lo que te trae paz',
      'categories.products': 'productos',
      
      // Best Sellers
      'bestSellers.badge': '⭐ FAVORITOS DE CLIENTES',
      'bestSellers.title': 'Más Vendidos',
      'bestSellers.subtitle': 'Confiados por miles para relajación',
      'bestSellers.cta': 'Explorar Todos los Productos',
      
      // USP
      'usp.shipping.title': 'Envío Gratis',
      'usp.shipping.text': 'En pedidos de $75+',
      'usp.returns.title': 'Devoluciones Fáciles',
      'usp.returns.text': 'Garantía de 30 días',
      'usp.secure.title': 'Pago Seguro',
      'usp.secure.text': 'Encriptación SSL',
      
      // Footer
      'footer.newsletter.title': 'Únete a Nuestra Comunidad Pacífica',
      'footer.newsletter.subtitle': 'Recibe consejos de bienestar, ofertas exclusivas e inspiración pacífica',
      'footer.newsletter.placeholder': 'Ingresa tu correo electrónico',
      'footer.newsletter.button': 'Suscribirse',
      'footer.tagline': 'Contra la ansiedad. Por la comodidad en cada hogar.',
      'footer.since': 'Desde 2024',
      'footer.shop': 'Tienda',
      'footer.collections': 'Colecciones',
      'footer.company': 'Empresa',
      'footer.shopBy': 'Comprar Por',
      'footer.categories': 'CATEGORÍAS',
      'footer.brands': 'MARCAS',
      'footer.weAccept': 'Aceptamos:',
      'footer.copyright': 'Hecho con atención plena.',
      'footer.privacy': 'Privacidad',
      'footer.terms': 'Términos',
      'footer.accessibility': 'Accesibilidad',
      
      // Product Card
      'product.addToCart': 'Agregar al Carrito',
      'product.addToWishlist': 'Agregar a Favoritos',
      'product.inStock': 'En stock',
      'product.outOfStock': 'Agotado',
      'product.lowStock': 'Stock bajo',
      'product.bestSeller': 'Más Vendido',
      'product.new': 'Nuevo',
      
      // Common
      'common.viewAll': 'Ver Todo',
      'common.loading': 'Cargando...',
      'common.allProducts': 'Todos los Productos',
      'common.newArrivals': 'Nuevos Productos',
      'common.sale': 'Oferta',
      'common.aboutUs': 'Sobre Nosotros',
      'common.helpCenter': 'Centro de Ayuda',
      'common.contact': 'Contacto'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
